<div class="ds-modal ds-modal--auto historial-dif">
    <div class="ds-accent"></div>

    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">insights</span>
        <div>
            <h2>Historial del diferencial</h2>
            <p *ngIf="data?.nombre">Solicitudes aprobadas y anuladas de {{ data.nombre }}</p>
        </div>
        <span class="ds-modal__spacer"></span>
        <button type="button" class="ds-icon-btn" (click)="dialogRef.close()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <div class="ds-modal__body">
        <app-spinner
            [show]="cargando"
            [text]="'Cargando historial...'"
            [type]="'absolute'"
            [color]="'#B1476A'"
            [trackColor]="'#4CA7C8'"
            [blurBackground]="true"
        ></app-spinner>

        <!-- Aprobadas y Anuladas lado a lado, cada una como columna vertical. -->
        <div class="historial-dif__columnas" *ngIf="!cargando">
            <div class="ds-card" *ngFor="let grupo of grupos">
                <div class="ds-section__head">
                    <span class="material-icons">{{ grupo.icono }}</span>
                    {{ grupo.titulo }}
                    <span class="ds-chip ds-chip--{{ grupo.chip }} historial-dif__count">
                        {{ items(grupo.key).length }}
                    </span>
                </div>

                <div class="ds-section__body">
                    <p class="historial-dif__vacio" *ngIf="!items(grupo.key).length">
                        Sin solicitudes en este estado.
                    </p>

                    <div class="historial-dif__grid" *ngIf="items(grupo.key).length">
                        <button
                            type="button"
                            class="historial-dif__item"
                            *ngFor="let item of items(grupo.key)"
                            (click)="verSolicitud(item)"
                            [title]="'Ver la solicitud #' + item.nro"
                        >
                            <span class="historial-dif__nro">#{{ item.nro }}</span>
                            <span class="historial-dif__fecha">{{ item.fecha | date: "dd/MM/yy" }}</span>
                            <span class="historial-dif__act">{{ item.actividad }}</span>
                            <span class="material-icons historial-dif__ojo">remove_red_eye</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--primary" (click)="dialogRef.close()">Cerrar</button>
    </div>
</div>
